export default __webpack_public_path__ + "static/media/InsideHeart_09.cf644ec2.png";